import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION4: PdfComponent = {
  type: 'section',
  id: 's1s4',
  title: '4. General Obligation to Comply with Data Privacy Laws',
  content: [
    {
      type: 'altText',
      id: 's1s4bullets',
      content: [
        'Each party shall comply with all applicable ',
        'Data Privacy Laws',
        'and shall not, by any act or omission, cause the other party to breach any Data Privacy Laws.',
      ],
      boldFirst: false,
    },
  ],
};
